import React, { useState, useEffect } from 'react';
import staffApi from '../../staffApi';

export default function SubmissionsModal({ test, onClose }) {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSubmissions();
  }, [test.id]);

  const loadSubmissions = async () => {
    try {
      setLoading(true);
      const data = await staffApi.getTestSubmissions(test.id);
      setSubmissions(data);
    } catch (error) {
      console.error('Error loading submissions:', error);
      alert('Failed to load submissions');
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (seconds) => {
    if (!seconds) return 'N/A';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Submissions - {test.title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        {loading ? (
          <div className="text-center py-8">Loading submissions...</div>
        ) : submissions.length === 0 ? (
          <div className="text-center py-8 text-gray-500">No submissions yet</div>
        ) : (
          <div className="space-y-4">
            {submissions.map((submission) => (
              <div key={submission.id} className="border border-gray-200 rounded-lg p-4">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      {submission.tutor_name || submission.tutor_email}
                    </h3>
                    <p className="text-sm text-gray-600">{submission.tutor_email}</p>
                    <div className="mt-2 text-sm text-gray-600 space-y-1">
                      <p>Status: <span className="font-medium">{submission.status}</span></p>
                      <p>Started: {new Date(submission.started_at).toLocaleString()}</p>
                      {submission.submitted_at && (
                        <p>Submitted: {new Date(submission.submitted_at).toLocaleString()}</p>
                      )}
                      {submission.time_taken_seconds && (
                        <p>Time Taken: {formatTime(submission.time_taken_seconds)}</p>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-2">
                    {submission.recording_url ? (
                      <a
                        href={submission.recording_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 text-center"
                      >
                        🎥 View Recording
                      </a>
                    ) : (
                      <div className="bg-gray-100 text-gray-600 px-3 py-1 rounded text-sm text-center">
                        ⏳ Recording not available yet
                      </div>
                    )}
                    {submission.daily_room_name && (
                      <div className="text-xs text-gray-500 mt-1">
                        Room: {submission.daily_room_name}
                      </div>
                    )}
                    {submission.daily_room_url && (
                      <a
                        href={submission.daily_room_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700 text-center"
                      >
                        🔗 Open Room
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

